<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoReporte
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <SelectChequera
                    :model="itemActivo.Id_Chequera"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarChequera"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoReporte from "@/components/EncabezadoReporte";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectChequera from "@/components/Banco/SelectChequera";
export default {
  name: "ChequeListarPorChequera",
  components: {
    EncabezadoReporte,
    PieCrud,
    Mensaje,
    SelectChequera
  },
  data() {
    return {
      titulo: "Cheques por Chequera",
      rutaApi: "Cheque/",
      itemVacio: {
        Id_CuentaBancaria: 0,
        NombreCuentaBancaria: "",
        Id_Chequera: 0,
        NombreChequera: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Imprimir":
        case "ExportarXls":
          if (this.$refs.form.validate()) this.imprimir();
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      eventBus.$emit("inicializarSelectChequera");
    },
    seleccionarChequera(item) {
      this.itemActivo.Id_CuentaBancaria = item.Id_CuentaBancaria;
      this.itemActivo.NombreCuentaBancaria = item.NombreCuentaBancaria;
      this.itemActivo.Id_Chequera = item.Id_Chequera;
      this.itemActivo.NombreChequera = item.Nombre;
    },
    imprimir() {
      this.loading = true;
      HttpHelper.getBlob(this.rutaApi + "ListarPorChequera", {
        accion: this.accion,
        id_CuentaBancaria: this.itemActivo.Id_CuentaBancaria,
        nombreCuentaBancaria: this.itemActivo.NombreCuentaBancaria,
        id_Chequera: this.itemActivo.Id_Chequera,
        nombreChequera: this.itemActivo.NombreChequera
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
